export default "__VITE_ASSET__CR$$VbGx__"